module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA3CAYAAABZ0InLAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABTSURBVHgB7djBDYBACEVB1th/y2gRZvXjTMKdd+FA1XDrnq65+qjhBKYTCAAAALCfv2g6gekEhpt8QAEAAPizVd/z6E7+oukEphsfeNZ7dhy3vgC1TQkdQbsBqAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-menu-opener-blk.png
// module id = aRDw
// module chunks = 19